// extracted by mini-css-extract-plugin
module.exports = {"control":"FormControl_control__ZMl4I","label":"FormControl_label__3F9Gy"};